import React from "react"
import MobileUtilityPageWrapper from "../../page_wrappers/MobileUtilityPageWrapper"
import ResetPassword from "../../views/ResetPassword"

const RequestPasswordLinkPage: React.FC = () => {
  return (
    <MobileUtilityPageWrapper title={""} footer={<></>}>
      <ResetPassword />
    </MobileUtilityPageWrapper>
  )
}

export default RequestPasswordLinkPage
